import _ from 'lodash'
import moment from 'moment'
import { vals } from '../../util'
import api from '../../axios_api'
import router from '../../main'
import Promise from 'bluebird'

let state = {
    referrerData: [],
    sentDeals: [],
    referrerChartData: {}
}

const getters = {
    getReffers: (state) => {
        return state.referrerData
    },
    getReffersLength: (state) => {
        return state.referrerData.length
    },
    teamMembers(state, rootGetters) {
        let data = state.referrerData && state.referrerData.length > 0
            ? JSON.parse(JSON.stringify(state.referrerData))
            : [];
        data = data.filter(item => item.isTeam);
        data.map(item => {
            if (item.account) {
                item.invested = [];
                item.rejected = [];
                item.referred = [];
                item.name =
                    item.account.firstName != item.account.lastName
                        ? `${item.account.firstName}  ${item.account.lastName}`
                        : item.account.firstName;
                item.roleName = item.role && item.role.name ? item.role.name : "";
                item.roleId = item.role && item.role._id ? item.role._id : "";
                item.image =
                    item.account && item.account.image ? item.account.image : "";
                if (item.account.google && item.account.google.email)
                    item.email = item.account.google.email;
                else if (item.account.twitter && item.account.twitter.email)
                    item.email = item.account.twitter.email;
                else if (item.account.facebook && item.account.facebook.email)
                    item.email = item.account.facebook.email;
                else if (item.account.linkedin && item.account.linkedin.email)
                    item.email = item.account.linkedin.email;
                else if (item.account.cognito && item.account.cognito.email)
                    item.email = item.account.cognito.email;
                else if (item.account.ltse && item.account.ltse.email)
                    item.email = item.account.ltse.email;
                item.portfolioData.map(portfolioItem => {
                    if (
                        portfolioItem &&
                        portfolioItem.entity_id &&
                        portfolioItem.entity_id._id
                    ) {
                        item.invested = [
                            ...item.invested,
                            portfolioItem.entity_id
                        ];
                        // item.referred = [
                        //     ...item.referred,
                        //     portfolioItem.entity_id
                        // ];
                    }
                });
                item.diligenceData.map(diligenceItem => {
                    // item.referred = [
                    //     ...item.referred,
                    //     diligenceItem.entity_id
                    // ];
                    if (
                        diligenceItem.entity_id && !(
                            diligenceItem.entity_id.hasOwnProperty("passedNotes") ||
                            diligenceItem.entity_id.hasOwnProperty("rejectedNotes")
                        )
                    ) {
                        item.referred.push(diligenceItem.entity_id);
                    }
                    else if (
                        diligenceItem &&
                        diligenceItem.entity_id &&
                        diligenceItem.entity_id.passedNotes &&
                        diligenceItem.entity_id.passedNotes.length > 0
                    ) {
                        item.invested = [
                            ...item.invested,
                            diligenceItem.entity_id
                        ];
                    }
                    else if (
                        diligenceItem &&
                        diligenceItem.entity_id &&
                        diligenceItem.entity_id.rejectedNotes &&
                        diligenceItem.entity_id.rejectedNotes.length > 0
                    ) {
                        item.rejected = [
                            ...item.rejected,
                            diligenceItem.entity_id
                        ];
                    }
                });
            }
        });
        return data;
    },
    referrerMembers: (state) => {
        let referrerData = state.referrerData && state.referrerData.length > 0
            ? JSON.parse(JSON.stringify(state.referrerData))
            : [];
        referrerData = referrerData.filter(item => item.isTeam == false);
        referrerData.map(item => {
            item.invested = [];
            item.rejected = [];
            item.referred = [];
            item.text = "";
            if (item && item.diligenceData && item.diligenceData.length > 0) {
                let diligenceData = item.diligenceData;
                diligenceData.map(diligenceItem => {
                    if (
                        diligenceItem.entity_id && !(
                            diligenceItem.entity_id.hasOwnProperty("passedNotes") ||
                            diligenceItem.entity_id.hasOwnProperty("rejectedNotes")
                        )
                    ) {
                        item.referred.push(diligenceItem.entity_id);
                    }
                    else if (
                        diligenceItem.entity_id &&
                        diligenceItem.entity_id.passedNotes &&
                        diligenceItem.entity_id.passedNotes.length > 0
                    ) {
                        item.invested.push(diligenceItem.entity_id);
                    }
                    else if (
                        diligenceItem.entity_id &&
                        diligenceItem.entity_id.rejectedNotes &&
                        diligenceItem.entity_id.rejectedNotes.length > 0
                    )
                        item.rejected.push(diligenceItem.entity_id);
                });
            }
            if (item && item.investData && item.investData.length > 0) {
                let investData = item.investData;
                investData.map(investItem => {
                    if (
                        investItem.entity_id &&
                        investItem.entity_id.portfolio_item
                    ) {
                        item.invested.push(investItem.entity_id);
                    }
                });
            }
            if (item.portfolioData && item.portfolioData.length > 0) {
                // item.referred = [...item.referred, ...item.portfolioData];
                let portfolioData = item.portfolioData;
                portfolioData.map(portfolioItem => {
                    if (
                        portfolioItem.entity_id &&
                        portfolioItem.entity_id._id
                    )
                        item.invested.push(portfolioItem.entity_id);
                });
            }
        });
        return referrerData;
    },
    getReffersChartData: (state) => {
        let data = JSON.parse(JSON.stringify(state.referrerData));
        if (data.length < 1) return {}
        let retval = { value: [], value_p: [], labels: [], totalDataLength: 0, data: [], groupByData: {} };
        retval.data = data;
        let totalCompaniesLength = 0;
        _.each(data, item => {
            if (item && item.isTeam) {
                if (item.account) {
                    item.name = item.account.lastName ? `${item.account.firstName} ${item.account.lastName}` : item.account.firstName;
                }
            }
            if (item && item.portfolioData && item.portfolioData.length > 0) {
                let portfolioData = JSON.parse(JSON.stringify(item.portfolioData));
                if (!item.investData) {
                    item.investData = [];
                }
                portfolioData.map((items) => {
                    let obj = items;
                    if (obj.entity_id) {
                        obj.entity_id.portfolio_item = obj.entity_id._id;
                    }
                    item.investData.push(obj);
                })
            }
            if (item && item.investData) {
                totalCompaniesLength += item.investData.length;
            }
            if (item && item.diligenceData) {
                let diligenceData = JSON.parse(JSON.stringify(item.diligenceData));
                item.diligenceData = diligenceData.filter((items) => {
                    if (items.entity_id) {
                        if (items.entity_id.passedNotes) {
                            if (items.entity_id.passedNotes != 'Invested') {
                                return items;
                            }
                        }
                        else {
                            return items;
                        }

                    }
                })
                totalCompaniesLength += item.diligenceData.length;
            }
        })
        retval.totalDataLength = totalCompaniesLength;
        if (totalCompaniesLength <= 0) return retval
        let groupBy = function (xs, key) {
            return xs.reduce(function (rv, x) {
                (rv[x[key]] = rv[x[key]] || []).push(x);
                return rv;
            }, {});
        };
        let groubedByData = groupBy(data, 'name');
        state.referrerChartData = groubedByData;
        retval.groupByData = groubedByData;
        retval.labels = Object.keys(groubedByData);
        _.each(retval.labels, item => {
            let singleReferrerCompamiesLength = 0;
            if (groubedByData[item] && groubedByData[item].length > 0 && groubedByData[item][0].investData) {
                singleReferrerCompamiesLength += groubedByData[item][0].investData.length;
            }
            if (groubedByData[item] && groubedByData[item].length > 0 && groubedByData[item][0].diligenceData) {
                singleReferrerCompamiesLength += groubedByData[item][0].diligenceData.length;
            }
            retval.value.push(singleReferrerCompamiesLength);
            retval.value_p.push((singleReferrerCompamiesLength / totalCompaniesLength * 100).toFixed(2))
        })
        return retval
    },
    getReffersTotalCompaniesLength: (state) => {
        let data = JSNO.parse(JSON.stringify(state.referrerData));
        let totalCompaniesLength = 0;
        _.each(data, item => {
            if (item && item.investData) {
                totalCompaniesLength += item.investData.length;
            }
            if (item && item.diligenceData) {
                totalCompaniesLength += item.diligenceData.length;
            }
        })
        return totalCompaniesLength
    },
    sentDeals: (state) => {
        let data = state.sentDeals.length > 0 ? JSON.parse(JSON.stringify(state.sentDeals)) : []
        data.map(item => {
            item.invested = 0;
            item.rejected = 0;
            item.referred = 0;
            if (item.account && item.account._id) {
                item.text = item.account.firstName != item.account.lastName ? `${item.account.firstName} ${item.account.lastName}` : item.account.firstName
            } else {
                item.text = item.email;
            }
            if (item.companies && item.companies.length > 0) {
                item.companies.map(companyItem => {
                    if (companyItem.action) {
                        if (companyItem.action.toLowerCase() == 'referred') item.referred++;
                        if (companyItem.action.toLowerCase() == 'passed') item.rejected++;
                        if (companyItem.action.toLowerCase() == 'invested') item.invested++;
                    }
                })
            }
        })
        return data;
    }
}

const mutations = {
    initialize(state) {
        state.referrerData = [];
        state.referrerChartData = {};
        state.sentDeals = [];
    },
    mergeSentDeals(state, payload) {
        // merge our local with what has returned
        if (_.isNil(payload) || _.isEmpty(payload)) return
        if (!_.isArray(payload)) payload = [payload]
        state.sentDeals = _.map(state.sentDeals, addr => {
            let index = _.findIndex(payload, function (a) { return a._id === addr._id })
            if (index >= 0) {
                return _.first(_.pullAt(payload, index))
            }
            return addr
        })
        if (!_.isEmpty(payload)) state.sentDeals = _.concat(state.sentDeals, payload)
        state.sentDeals = _.without(state.sentDeals, null, undefined)
    },
    merge(state, payload) {
        // merge our local with what has returned
        if (_.isNil(payload) || _.isEmpty(payload)) return
        if (!_.isArray(payload)) payload = [payload]
        state.referrerData = _.map(state.referrerData, addr => {
            let index = _.findIndex(payload, function (a) { return a._id === addr._id })
            if (index >= 0) {
                return _.first(_.pullAt(payload, index))
            }
            return addr
        })
        if (!_.isEmpty(payload)) state.referrerData = _.concat(state.referrerData, payload)
        state.referrerData = _.without(state.referrerData, null, undefined)
    },
    remove(state, payload) {
        if (_.isNil(payload) || _.isEmpty(payload)) return
        // remove the item by the id (either _id or uaid)
        state.referrerData = _.filter(state.referrerData, function (a) { return a._id !== payload && a.uaid !== payload })
    },
    updateTeam(state, payload) {
        if (_.isNil(payload) || _.isEmpty(payload)) return
        let data = state.referrerData.find(item => item.isTeam && payload._id == item._id);
        if (data && data.role) {
            data.roleName = payload.role && payload.role.name ? payload.role.name : '';
            data.roleId = payload.roleId
            data.role = payload.role
        }
    },
    updateReferrer(state, payload) {
        if (_.isNil(payload) || _.isEmpty(payload)) return
        let data = state.referrerData.find(item => !item.isTeam && payload._id == item._id);
        if (data && data._id) {
            data.email = payload.email;
            data.name = payload.name;
        }
    }
}

const actions = {
    start({ state, dispatch, commit }) {
        commit('initialize')
        dispatch('apiFetchsentDeals');
        dispatch('getReffers');
    },
    stop({ commit }) {
        // clean up
        commit('initialize')
    },
    getReffers({ commit }) {
        if (localStorage.fiifi) {
            let fiifi = JSON.parse(localStorage.fiifi).user
            if (fiifi && fiifi.workspace_id && fiifi.workspace_id.length > 0) {
                let url = `/${fiifi.id}/${fiifi.workspace_id}/referrers`
                return api.get(url, {})
                    .then(res => {
                        commit('merge', res.data.encrypt.success)
                        return Promise.resolve(res.data.encrypt.success)
                    })
                    .catch(err => {
                        console.error(`Error during referrerData fetch: ${err}`)
                        return Promise.reject(err)
                    })
            }
        }
    },
    apiEditUser({ rootGetters, dispatch, commit }, payload) {
        let url = `/edit/user`;
        return api.put(url, { encrypt: { data: payload } })
            .then(res => {
                dispatch('getReffers')
                    .then(() => {
                    })
                    .catch(() => { })
                return new Promise.resolve(res.data.encrypt.success);
            })
            .catch(err => {
                return Promise.reject(err)
            })
    },
    apiEditReferrer({ commit, dispatch }, payload) {
        let url = `${router.currentRoute.params.account_id}/${router.currentRoute.params.workspace_id}/referrer`
        return api.patch(url, { encrypt: { data: payload } })
            .then(res => {
                dispatch('getReffers')
                    .then(() => {
                    })
                    .catch(() => { })
                return Promise.resolve(res.data.encrypt.success)
            })
            .catch(err => {
                console.error(`Error during referrerData fetch: ${err}`)
                return Promise.reject(err)
            })
    },
    apiDeleteReferrer({ commit, dispatch }, payload) {
        let url = `${router.currentRoute.params.account_id}/${router.currentRoute.params.workspace_id}/delete/referrer`
        return api.post(url, { encrypt: { data: [payload] } })
            .then(res => {
                commit('remove', payload)
                return Promise.resolve(res.data.encrypt.success)
            })
            .catch(err => {
                console.error(`Error during referrerData fetch: ${err}`)
                return Promise.reject(err)
            })
    },
    apiBulkDeleteReferrer({ commit, dispatch }, payload) {
        let url = `${router.currentRoute.params.account_id}/${router.currentRoute.params.workspace_id}/delete/referrer`
        return api.post(url, { encrypt: { data: payload } })
            .then(res => {
                payload.map(item => {
                    commit('remove', item)
                })
                return Promise.resolve(res.data.encrypt.success)
            })
            .catch(err => {
                console.error(`Error during referrerData fetch: ${err}`)
                return Promise.reject(err)
            })
    },
    apiAddReferrerTeam({ commit, dispatch }, payload) {
        let url = `/add/referrer/team`
        return api.patch(url, { encrypt: { data: payload } })
            .then(res => {
                if (payload.referrer)
                    commit('remove', payload.referrer)
                return Promise.resolve(res.data.encrypt.success)
            })
            .catch(err => {
                console.error(`Error during referrerData fetch: ${err}`)
                return Promise.reject(err)
            })
    },
    apiPostSentDeal({ commit, dispatch }, payload) {
        let url = `/${router.currentRoute.params.workspace_id}/sent_deal`
        return api.post(url, { encrypt: { data: payload } })
            .then(res => {
                dispatch('apiFetchsentDeals');
                return Promise.resolve(res.data.encrypt.success)
            })
            .catch(err => {
                console.error(`Error during post sent deal fetch: ${err}`)
                return Promise.reject(err)
            })
    },
    apiFetchsentDeals({ commit }) {
        if (localStorage.fiifi) {
            let fiifi = JSON.parse(localStorage.fiifi).user
            if (fiifi && fiifi.workspace_id && fiifi.workspace_id.length > 0) {
                let url = `/${fiifi.workspace_id}/sent_deal`
                return api.get(url)
                    .then(res => {
                        commit('mergeSentDeals', res.data.encrypt.success)
                        return Promise.resolve(res.data.encrypt.success)
                    })
                    .catch(err => {
                        console.error(`Error during referrerData fetch: ${err}`)
                        return Promise.reject(err)
                    })
            }
        }
    },
    apiEditSentDeals({ commit, dispatch }, payload) {
        let url = `/${router.currentRoute.params.workspace_id}/sent_deal`
        return api.patch(url, { encrypt: { data: payload } })
            .then(res => {
                dispatch('apiFetchsentDeals');
                return Promise.resolve(res.data.encrypt.success)
            })
            .catch(err => {
                return Promise.reject(err)
            })
    },
}

export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions
}